import { useState, useCallback } from 'react';
import { j218Api, FJ730 } from '../../../services/j218Api';

interface LookupNames {
  employee: string;
  department: string;
  usage: string;
  devOrder: string;
  [key: string]: string;
}

export function useLookupNames() {
  const [names, setNames] = useState<LookupNames>({
    employee: '',
    department: '',
    usage: '',
    devOrder: '',
  });

  const resolveSingleName = useCallback(async (key: string, type: string, code: string) => {
    const name = await j218Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [key]: name }));
  }, []);

  const resolveAllNames = useCallback(async (data: FJ730) => {
    const [emp, dept, usage, dev] = await Promise.all([
      j218Api.lookupName('employee', data.fj730_62),
      j218Api.lookupName('department', data.fj730_63),
      j218Api.lookupName('usage', data.fj730_13),
      j218Api.lookupName('devorder', data.fj730_11),
    ]);
    setNames({ employee: emp, department: dept, usage, devOrder: dev });
  }, []);

  const clearNames = useCallback(() => {
    setNames({ employee: '', department: '', usage: '', devOrder: '' });
  }, []);

  return { names, resolveAllNames, resolveSingleName, clearNames };
}
